import { createReducer, on } from '@ngrx/store';
import * as RolePermissionActions from '../actions/role-permission.actions';
import { initialRolePermissionState, ROLE_PERMISSION_CACHE_CONFIG } from '../state/role-permission.state';

export const rolePermissionReducer = createReducer(
    initialRolePermissionState,

    // Load Role and Permission Menu
    on(RolePermissionActions.loadRoleAndPermissionMenu, (state, { username, forceRefresh }) => ({
        ...state,
        loading: true,
        error: null,
        currentUsername: username,
        // Clear data if force refresh or different user
        data: (forceRefresh || state.currentUsername !== username) ? null : state.data
    })),

    on(RolePermissionActions.loadRoleAndPermissionMenuSuccess, (state, { roleAndPermissionMenu, username }) => {
        const now = Date.now();
        return {
            ...state,
            data: roleAndPermissionMenu,
            loading: false,
            error: null,
            lastFetchTimestamp: now,
            cacheValidUntil: now + ROLE_PERMISSION_CACHE_CONFIG.CACHE_DURATION_MS,
            cachedForUsername: username,
            currentUsername: username,
            isInitialized: true,
            hasCachedData: true
        };
    }),

    on(RolePermissionActions.loadRoleAndPermissionMenuFailure, (state, { error, username }) => ({
        ...state,
        loading: false,
        error: error,
        currentUsername: username
    })),

    // Cache Management
    on(RolePermissionActions.loadFromCache, (state, { username }) => ({
        ...state,
        loadingFromCache: true,
        currentUsername: username
    })),

    on(RolePermissionActions.loadFromCacheSuccess, (state, { roleAndPermissionMenu, username }) => ({
        ...state,
        data: roleAndPermissionMenu,
        loadingFromCache: false,
        currentUsername: username,
        isInitialized: true,
        hasCachedData: true
    })),

    on(RolePermissionActions.loadFromCacheFailure, (state, { username }) => ({
        ...state,
        loadingFromCache: false,
        currentUsername: username,
        hasCachedData: false
    })),

    on(RolePermissionActions.clearRoleAndPermissionMenuCache, (state) => ({
        ...state,
        data: null,
        lastFetchTimestamp: null,
        cacheValidUntil: null,
        cachedForUsername: null,
        hasCachedData: false,
        error: null
    })),

    // User Management
    on(RolePermissionActions.userChanged, (state, { username }) => {
        // If same user, keep existing state
        if (state.currentUsername === username) {
            return state;
        }

        // Different user - reset most state but keep cache info for comparison
        return {
            ...state,
            currentUsername: username,
            loading: false,
            loadingFromCache: false,
            error: null,
            // Keep data only if cache is for this user and still valid
            data: (state.cachedForUsername === username &&
                state.cacheValidUntil &&
                Date.now() < state.cacheValidUntil) ? state.data : null
        };
    }),

    on(RolePermissionActions.resetState, () => ({
        ...initialRolePermissionState
    }))
);
